import brandLogoMark from "@/assets/brand-logo-mark.png";
import { brand } from "@/config/brand";
import { cn } from "@/lib/utils";

interface AppLogoProps {
  className?: string;
  /** "sidebar" = 38px tile (navy rail); "panel" = 42px tile (auth brand panel);
   * "compact" = 38px tile with dark wordmark (mobile auth header on light bg). */
  variant?: "sidebar" | "panel" | "compact";
  /** Hide the wordmark text (e.g. a collapsed sidebar) — show just the mark tile. */
  showWordmark?: boolean;
}

/** The NSI mark: the `brand-logo-mark.png` asset on a white rounded tile. */
function Mark({ size }: { size: number }) {
  return (
    <img
      src={brandLogoMark}
      alt=""
      draggable={false}
      className="shrink-0 rounded-sm bg-white object-contain"
      style={{ width: size, height: size }}
    />
  );
}

/**
 * Brand logo lockup (Calm Studio): the NSI mark tile + a two-line wordmark
 * ("NSI Capitals" / "Tax Resolution"). The wordmark is white on the dark
 * sidebar/brand panels and dark in the compact (light-bg) variant.
 */
export function AppLogo({ className, variant = "panel", showWordmark = true }: AppLogoProps) {
  const size = variant === "panel" ? 42 : 38;
  const dark = variant === "compact";
  return (
    <div className={cn("flex items-center gap-3", className)}>
      <Mark size={size} />
      {showWordmark && (
        <div className="flex flex-col leading-[1.1]">
          <span
            className={cn(
              "font-heading text-[17px] font-bold tracking-[-0.01em]",
              dark ? "text-foreground" : "text-white",
            )}
          >
            {brand.name}
          </span>
          <span
            className={cn(
              "text-[11px] tracking-[0.08em] uppercase",
              dark ? "text-muted-foreground" : "text-sidebar-muted",
            )}
          >
            Tax Resolution
          </span>
        </div>
      )}
    </div>
  );
}
